// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const Check = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 9">
            <path
                fill="currentColor"
                d="m11 1.1-.417.425-6.225 6.303-.415.422-.415-.422L.417 4.676 0 4.254l.832-.85.418.423 2.693 2.729L9.75.673l.418-.423.832.85z"
            />
        </svg>
    );
};

export default React.memo(Check);
